import styled from 'styled-components';
import AppCSS from '../../../../../utils/styled';
import { CellType } from '../../../../../api/types/others';

export const Components = {
  Container: styled.div<{ type: CellType }>`
    width: 150px;
    aspect-ratio: 1;
    border-radius: 4px;
    border: 3px solid ${AppCSS.colors.greys.veryDark};
    display: flex;
    flex-direction: ${({ type }) => {
      switch (type) {
        case 'wideList':
          return 'column';
      }
    }};
    align-items: center;
    justify-content: ${({ type }) => {
      switch (type) {
        case 'largeCarousel':
        case 'pillarCard':
          return 'space-around';
        case 'wideList':
        case 'listCard':
        case 'twoColumnsList':
        case 'simpleCard':
        case 'playProgressCard':
        case 'simpleCard2':
          return 'space-evenly';
        case 'defaultCarousel':
        case 'authorCarousel':
          return '';
      }
    }};
    ${({ type }) => (type === 'pillarCard' ? 'flex-wrap: wrap' : '')};
  `,

  FullHeightItem: styled.div`
    height: 90%;
    width: 70%;
    background-color: ${AppCSS.colors.greys.prettyDark};
    border-radius: 8px;
  `,

  VerticalBar: styled.div`
    height: 90%;
    width: 10%;
    background-color: ${AppCSS.colors.greys.prettyDark};
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  `,

  VerticalBar2: styled.div`
    height: 90%;
    width: 10%;
    background-color: ${AppCSS.colors.greys.prettyDark};
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  `,

  WideItem: styled.div`
    width: 90%;
    height: 40%;
    background-color: ${AppCSS.colors.greys.prettyDark};
    border-radius: 8px;
  `,

  DefaultCarouselItem: styled.div`
    height: 70%;
    width: 55%;
    background-color: ${AppCSS.colors.greys.prettyDark};
    margin-left: 8px;
    border-radius: 8px;
  `,

  DefaultCarouselItem2: styled.div`
    height: 70%;
    width: 35%;
    background-color: ${AppCSS.colors.greys.prettyDark};
    margin-left: 8px;
    border-bottom-left-radius: 8px;
    border-top-left-radius: 8px;
  `,

  PillarCircle: styled.div`
    width: 27%;
    aspect-ratio: 1;
    border-radius: 50%;
    background-color: ${AppCSS.colors.greys.prettyDark};
  `,

  InvisibleCircle: styled.div`
    width: 27%;
    aspect-ratio: 1;
    border-radius: 50%;
    background-color: transparent;
  `,

  ListColumnItem: styled.div`
    height: 60%;
    width: 40%;
    background-color: ${AppCSS.colors.greys.prettyDark};
    border-radius: 8px;
  `,

  AuthorCarouselItem: styled.div`
    height: 70%;
    width: 55%;
    background-color: ${AppCSS.colors.greys.prettyDark};
    margin-left: 8px;
    border-radius: 8px;
  `,

  AuthorCarouselItem2: styled.div`
    height: 70%;
    width: 35%;
    background-color: ${AppCSS.colors.greys.prettyDark};
    margin-left: 8px;
    border-bottom-left-radius: 8px;
    border-top-left-radius: 8px;
  `,

  AuthorCarouselTitle: styled.div`
    position: absolute;
    top: 80px;
    left: 30px;
    width: 30px;
    height: 20px;
    background-color: ${AppCSS.colors.white};
    z-index: 1;
  `,

  AuthorCarouselContainer: styled.div`
    position: relative;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  `,

  PlayProgressCardItem: styled.div`
    width: 50%;
    height: 70%;
    background-color: ${AppCSS.colors.greys.prettyDark};
    border-radius: 8px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 12px;
    margin-left: 2px;
    margin-right: 2px;
    margin-bottom: 8px;

    &::after {
      content: '';
      position: absolute;
      bottom: 12px;
      left: 12px;
      right: 12px;
      height: 4px;
      background-color: ${AppCSS.colors.white};
      border-radius: 2px;
    }
  `,

  SimpleCard2Item: styled.div`
    height: 40%;
    width: 40%;
    background-color: ${AppCSS.colors.greys.prettyDark};
    border-radius: 8px;
    margin: 0 4px;
  `,
};
